export enum FiltroOrdenacaoRelatorio {
    QUANTIDADE = 'QUANTIDADE',
    CUSTO = 'CUSTO',
    PRECO = 'PRECO',
    CUSTO_TOTAL = 'CUSTO_TOTAL',
    PRECO_TOTAL = 'PRECO_TOTAL',
    PORCENTAGEM_DO_CUSTO = 'PORCENTAGEM_DO_CUSTO',
    PORCENTAGEM_DO_LUCRO = 'PORCENTAGEM_DO_LUCRO',
    LUCRO = 'LUCRO',
}
